<template>
  <app-tooltip
    placement="right"
    :heading="label"
    :disabled="!compact"
  >
    <list-item
      :to="to"
      :class="{ 'justify-center p-2!': compact }"
      :on-navigate="onNavigate"
      @click="emit('click')"
    >
      <slot name="prefix" />
      <template v-if="!compact">
        <span class="font-semibold">
          {{ label }}
        </span>
        <slot name="suffix" />
      </template>
    </list-item>
  </app-tooltip>
</template>

<script setup>
import ListItem from '@/components/ui/list/ListItem.vue';

defineProps({
  to: {
    type: [String, Object],
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  onNavigate: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(['click']);
</script>
